import React from 'react';

import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { routes } from 'utils/routing';

import { ButtonContainer, Container, StyledText, Title } from './styled';
import { IItemUnavailableData, MenuItemUnavailableProps } from './types';

export const MenuItemUnavailable: React.FC<React.PropsWithChildren<MenuItemUnavailableProps>> = ({
  isOffer,
}) => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const backToMenu = () => (router.canDismiss() ? router.dismiss() : router.replace(routes.menu));
  const backToOffers = () => () =>
    router.canDismiss() ? router.dismiss() : router.replace(routes.offers);

  const menuItemUnavailableData: IItemUnavailableData = isOffer
    ? {
        title: 'offerNotAvailable',
        content: 'chooseDifferentOffer',
        buttonLabel: 'backToOffers',
        cta: backToOffers,
      }
    : {
        title: 'itemNotAvailable',
        content: 'chooseDifferentItem',
        buttonLabel: 'backToMenu',
        cta: backToMenu,
      };

  const { title, content, buttonLabel, cta } = menuItemUnavailableData;

  const titleMessage = formatMessage({ id: title });

  useLogUserErrorMessage({
    message: titleMessage,
    severity: LogUserErrorSeverity.Recoverable,
    context: {
      moreInfo: 'menu-item-unavailable.tsx',
    },
  });

  return (
    <Container>
      <Title variant="headerOne" testID="menu-item-unavailable-title">
        {titleMessage}
      </Title>
      <StyledText variant="copyOne">
        {formatMessage({ id: 'selectionNotAvailable' })}
        {'\n'}
        {formatMessage({ id: content })}
      </StyledText>
      <ButtonContainer>
        <ActionButton testID="menu-item-unavailable-cta" fullWidth onPress={cta}>
          {formatMessage({ id: buttonLabel })}
        </ActionButton>
      </ButtonContainer>
    </Container>
  );
};
